import React, { useState, useEffect, useRef } from "react";
import * as Types from "../types/BaseTypes";

import { useTrail, animated } from "react-spring";

export default (props: {
  core?: { get: Types.Core; set: Function };
  height?: { get: Types.HeightFactor; set: Function };
  type: any;
  typePrimitive: string;
  data: { value: any; title: string; mobile?: string }[];
  getSliderLeft: Function;
  newPanelDirection?: Function;
  style?: {};
  mobileWidth?: number;
}) => {
  const {
    core,
    height,
    type,
    typePrimitive,
    data,
    getSliderLeft,
    newPanelDirection,
    style,
    mobileWidth
  } = props;

  const [isMobile, setIsmobile] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  const sliderSize = data.length;
  const width = ref.current ? ref.current.offsetWidth : 0;
  const calculations = [
    [],
    [5 + 8, (width / 2) * 1 + 5 + 8],
    [5 + 10, (width / 3) * 1 + 5 + 10, (width / 3) * 2 + 5 + 10],
    [
      5 + 10,
      (width / 4) * 1 + 5 + 10,
      (width / 4) * 2 + 5 + 10,
      (width / 4) * 3 + 5 + 10
    ]
  ];
  const [navSize, setNavSize] = useState<number[]>(
    calculations[sliderSize - 1]
  );
  const handleResize = () => {
    const width = ref.current ? ref.current.offsetWidth : 0;
    setIsmobile(mobileWidth ? width < mobileWidth : width < 815);
    switch (sliderSize) {
      case 2:
        setNavSize([5 + 8, (width / 2) * 1 + 5 + 8]);
        break;
      case 3:
        setNavSize([5 + 8, (width / 3) * 1 + 5 + 8, (width / 3) * 2 + 5 + 8]);
        break;
      case 4:
        setNavSize([
          5 + 8,
          (width / 4) * 1 + 5 + 8,
          (width / 4) * 2 + 5 + 8,
          (width / 4) * 3 + 5 + 8
        ]);
        break;
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, [ref.current]);
  useEffect(() => {
    handleResize();
  }, [core && core.get]);

  const trail = useTrail(1, { left: navSize[getSliderLeft()] });

  const displayTitle = (props: { item: any }) => {
    const { item } = props;
    if (isMobile && "mobile" in item) return item.mobile;
    return item.title;
  };

  return (
    <div ref={ref} className={"slider-wrap"} style={style}>
      {trail.map(({ left }, index) => (
        <animated.div
          key={index}
          className={"slider"}
          style={{ left, width: `calc(${100 / sliderSize}% - 26px)` }}
        ></animated.div>
      ))}
      {data.map((item, key) => (
        <div
          key={key}
          className={type === item.value ? "active" : ""}
          onClick={() => {
            core && core.set({ ...core.get, [typePrimitive]: item.value });
            height && height.set(item.value);
            newPanelDirection && newPanelDirection(item.value);
          }}
        >
          {displayTitle({ item: item })}
        </div>
      ))}
    </div>
  );
};
